





















import { sortBy } from 'lodash';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ItemsList extends Vue {
  @Prop() private data!: [];
  @Prop() private loading!: boolean;
  @Prop() private columns!: object[];
  @Prop() private pagination!: object;

  @Prop() private handleEdit!: any;
  @Prop() private handleDelete!: any;
}
